import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const ActionCardContainer = styled.div<{ active?: boolean }>`
  background: white;
  display: grid;
  grid-template-rows: 2fr 3fr;
  min-height: 23rem;
  box-shadow: var(--card-shadow);
  border-radius: 2px;
  cursor: pointer;

  transition: box-shadow 0.2s;
  border: 2px solid transparent;

  &:hover {
    box-shadow: var(--card-shadow-hover);
  }

  &:active {
    box-shadow: var(--card-shadow-active);
  }

  @media ${BREAKPOINTS.MD.max} {
    grid-template-rows: 1fr;
    min-height: 0;
  }

  ${({ active }) => {
    if (active) {
      return css`
        border-color: var(--c-blue500);
      `
    }
    return null
  }}
`

export const ActionCardIcon = styled.div<{ active?: boolean }>`
  margin: 1.5625rem;
  flex-grow: 1;

  ${({ active }) => {
    if (active) {
      return css`
        color: var(--c-blue500);
      `
    }

    return css`
      color: var(--c-gray500);
    `
  }}
  & img {
    width: 5.3125rem;
    height: 2.25rem;
    object-fit: contain;
    object-position: left;
  }
`

export const ActionCardContent = styled.div`
  margin: 1.5625rem;
  display: flex;
  flex-direction: column;

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 0;
  }
`

export const ActionCardTitle = styled.strong`
  font-family: var(--f-text);
  font-style: normal;
  font-weight: bold;
  font-size: 1.625rem;
  line-height: 1.23;
  margin-bottom: ${pxToRem(45)}rem;
  word-break: break-word;
  color: var(--c-blue500);

  flex-grow: 1;

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: ${pxToRem(24)}rem;
  }
`

export const ActionCardDescription = styled.span`
  font-family: var(--f-text);
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.6875;
  color: var(--c-gray500);

  display: flex;
  align-items: flex-end;
`
